import { LegalClientKnowledgeAndExperienceEntity } from 'api/types/entity';
import { yesOrNotOption } from 'helpers';
import { TFunc } from 'libs/i18n';

import { KnowledgeAndExperienceFormType } from '../../forms/knowledgeAndExperienceForm';

export const parseKnowledgeAndExperienceValue = (
  t: TFunc,
  knowledgeAndExperience?: LegalClientKnowledgeAndExperienceEntity
): KnowledgeAndExperienceFormType['knowledgeAndExperience'] => ({
  educationLevel: knowledgeAndExperience?.educationLevel
    ? {
        label: t(
          `client.client.knowledgeAndExperience.education.types.${knowledgeAndExperience.educationLevel}`
        ),
        value: knowledgeAndExperience.educationLevel,
      }
    : undefined,

  financialInstruments: knowledgeAndExperience?.financialInstruments?.map(
    (v) => ({
      label: t(
        `client.legal.legalKnowledgeAndExperience.financialInstruments.types.${v}`
      ),
      value: v,
    })
  ),

  hasQualifiedOfficersForInvestmentDecisions: yesOrNotOption(
    t,
    knowledgeAndExperience?.hasQualifiedOfficersForInvestmentDecisions
  ),
  heldFinancialPositionInLast5Years: yesOrNotOption(
    t,
    knowledgeAndExperience?.heldFinancialPositionInLast5Years
  ),
  otherFinancialInstrument: knowledgeAndExperience?.otherFinancialInstrument,
});
